import React, { useMemo } from 'react';
import ProductCard from '../components/ProductCard';
import { useApp } from '../context/AppContext';

export default function Products() {
  const { state, dispatch } = useApp();

  const filteredProducts = useMemo(() => {
    let filtered = state.products;

    if (state.selectedCategory !== 'all') {
      filtered = filtered.filter(product => product.category === state.selectedCategory);
    }

    if (state.searchQuery) {
      const query = state.searchQuery.toLowerCase();
      filtered = filtered.filter(product =>
        product.name.toLowerCase().includes(query) ||
        product.description.toLowerCase().includes(query) ||
        product.scent.toLowerCase().includes(query)
      );
    }

    return filtered;
  }, [state.products, state.selectedCategory, state.searchQuery]);

  const clearSearch = () => {
    dispatch({ type: 'SET_SEARCH_QUERY', payload: '' });
    dispatch({ type: 'SET_CATEGORY', payload: 'all' });
  };

  return (
    <div className="min-h-screen bg-black py-4 sm:py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-6 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">Fragrances for Men - Signature Scents by AKIDO™</h1>
          <p className="text-gray-400 text-sm sm:text-base md:text-lg max-w-2xl mx-auto">
            Discover our premium collection of signature fragrances crafted for the modern man
          </p>
        </div>

        {state.searchQuery && (
          <div className="mb-6 sm:mb-8 text-center">
            <p className="text-gray-300 text-sm sm:text-base">
              Showing results for: <span className="text-red-400 font-semibold">"{state.searchQuery}"</span>
            </p>
            <button
              onClick={clearSearch}
              className="mt-2 text-red-400 hover:text-red-300 underline text-sm"
            >
              Clear search
            </button>
          </div>
        )}

        {filteredProducts.length > 0 ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {filteredProducts.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        ) : (
          <div className="text-center py-12 sm:py-16">
            <div className="text-4xl sm:text-6xl mb-4">🔍</div>
            <h3 className="text-xl sm:text-2xl font-bold text-white mb-2">No products found</h3>
            <p className="text-gray-400 mb-4 sm:mb-6 text-sm sm:text-base">
              {state.searchQuery 
                ? `No products match "${state.searchQuery}". Try adjusting your search.`
                : 'No products found in this category.'}
            </p>
            <button
              onClick={clearSearch}
              className="bg-red-500 hover:bg-red-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-full font-semibold transition-colors text-sm sm:text-base"
            >
              Clear Filters
            </button>
          </div>
        )}
      </div>
    </div>
  );
}